export const mapFileExtByMimeType: Record<string, string> = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png',
  zip: 'application/zip',
  rar: 'application/x-rar',
  xml: 'text/xml',
};
